<template>
  <div class="Radio">
    <label class="question" :for="randomId">{{ questionString }}</label>
    <div class="optionsWrapper">
      <label v-if="!confirmOnly" class="option" :for="`${randomId}-false`"
        >{{
          getOptionText(option2Text, $mlGet("rmaTransport-default-option2"))
        }}
        <input
          type="radio"
          :id="`${randomId}-false`"
          :value="0"
          v-model="radioValue"/>
        <span class="checkmark"></span
      ></label>

      <label class="option" :for="`${randomId}-true`"
        >{{
          getOptionText(option1Text, $mlGet("rmaTransport-default-option1"))
        }}
        <input
          type="radio"
          :id="`${randomId}-true`"
          :value="1"
          v-model="radioValue"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class NullableRadio extends Vue {
  public randomId = Math.random().toString(36);

  @Prop() public questionString!: string;
  @Prop() public option1Text?: string;
  @Prop() public option2Text?: string;
  @Prop({
    default: false
  })
  public confirmOnly?: boolean;

  mounted() {
    this.radioValue = this.value;
  }

  @Prop({ default: -1 })
  public value!: number;

  public radioValue = -1;

  @Watch("value")
  public onValueChange() {
    this.radioValue = this.value;
  }

  @Watch("radioValue")
  @Emit("input")
  public onRadioValueChange() {
    return this.radioValue;
  }

  getOptionText(option: string | undefined, fallback: string): string {
    return option ? option : fallback;
  }
}
</script>

<style scoped>
.optionsWrapper {
  padding-top: 1ex;
  display: flex;
  gap: 1em;
}

/* The container */
.option {
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 5px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.option input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.option:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.option input:checked ~ .checkmark {
  background-color: #da6f38;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.option input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.option .checkmark:after {
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: white;
}
</style>
